<mat-dialog-content class="custom-modal-container">
  <h5 class="text-center text-black" mat-dialog-title>Information deal</h5>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-md-12">
          <span class="text-black">
            <strong>Comment:</strong>
            {{ data.comment }}
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="data?.showInformationBanksAgents?.length > 0 " class="col-lg-12">
      <div class="row">
        <div class="col-md-6">
          <span class="text-black">
            <strong>Bank name:</strong>
            {{ data?.bankName ?? 'N/A' }}
          </span>
        </div>
        <div class="col-md-6">
          <span class="text-black">
            <strong>Purchased Price:</strong>
            {{ data?.purchasedPrice ?? 'N/A' }}
          </span>
        </div>
        <div class="col-md-6">
          <span class="text-black">
            <strong>Payment:</strong>
            {{ data?.payment ?? 'N/A' }}
          </span>
        </div>
        <div class="col-md-6">
          <span class="text-black">
            <strong>Factor Rate:</strong>
            {{ data?.factorRate ?? 'N/A' }}
          </span>
        </div>
        <div class="col-md-6">
          <span class="text-black">
            <strong>Purchased Amount:</strong>
            {{ data?.purchasedAmount ?? 'N/A' }}
          </span>
        </div>
        <div class="col-md-6">
          <span class="text-black">
            <strong>Purchased Amount:</strong>
            {{ data?.purchasedAmount ?? 'N/A' }}
          </span>
        </div>
        <div class="col-md-6">
          <span class="text-black">
            <strong>Term Amount:</strong>
            {{ data?.term?.termAmount ?? 'N/A' }}
          </span>
        </div>
        <div class="col-md-6">
          <span class="text-black">
            <strong>Frequency:</strong>
            {{ data?.term?.frequency ?? 'N/A' | lowercase}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <mat-dialog-actions class="text-black justify-content-center">
    <button
      (click)="close()"
      class="btn btn-block btn-sm btn-default text-white"
      mat-button
    >
      Close
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
